import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  CategoryActionTypes,
  ThrowCategoryError,
  FireCategorySuccess,
  CategoriesPageRequested,
  CategoriesPageToggleLoading,
  CategoriesPageCancelled,
  CategoriesPageLoaded,
  CategoriesCheckDefaultTeamExists,
  CategoriesToggleDefaultTeamExists,
  CategoryStatusUpdated,
} from '../_actions/category.actions';
import { Router } from '@angular/router';
import { CategoryService } from '../_services';
import { QueryParamsModel } from '../../_base/crud';

@Injectable()
export class CategoryEffects {
  @Effect()
  loadCategoriesPage$ = this.actions$.pipe(
    ofType<CategoriesPageRequested>(CategoryActionTypes.CategoriesPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(new CategoriesPageToggleLoading({ isLoading: true }));
      const requestToServer = this.category.findCategories(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new CategoriesPageCancelled();
            } else {
              this.store.dispatch(new ThrowCategoryError({ error: response[0].error }));
              return new CategoriesPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            return new CategoriesPageLoaded({
              categories: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  updateStatusCategory$ = this.actions$.pipe(
    ofType<CategoryStatusUpdated>(CategoryActionTypes.CategoryStatusUpdated),
    mergeMap(({ payload }) => {
      return this.category.updateStatusCategory(payload.category, payload.isActive).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowCategoryError({ error: res.error });
          } else {
            return new FireCategorySuccess({
              action_type: CategoryActionTypes.CategoryStatusUpdated,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  checkDefaultTeamExists$ = this.actions$.pipe(
    ofType<CategoriesCheckDefaultTeamExists>(CategoryActionTypes.CategoriesCheckDefaultTeamExists),
    mergeMap(() => {
      return this.category.checkDefaultInterventionTeam().pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowCategoryError({ error: res.error });
          } else {
            return new CategoriesToggleDefaultTeamExists({ defaultTeamExists: res.length > 0 });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private category: CategoryService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
